import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_SIMRESULT_REGISTRY_KEY, META_TYPE, META_VER } from './simResultCommandRegisteryType';

/**
 * Registers the /sim command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /sim results — opens the SimResultWidget card.
 */
export function registerSimResultCommand() {
    commandEngine.register('/sim', {
        hint: 'Open sim results',
        params: [{ name: 'view', options: [{ label: 'Results', value: 'results' }] }],
        handler: () => {
            cardPainterManager.openCard(CMD_SIMRESULT_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
